import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { COLORS, TYPO, CARD_PAD } from "../../styles/uiConstants";

/**
 * Analiz sekmelerinin üstündeki KPI kutucuğu (design-principles §4): uppercase
 * etiket, büyük değer, altta soluk açıklama. Yüklenirken yalnız değer ve
 * açıklama iskelet olur; etiket yerinde kalır.
 *
 * @param {string} label
 * @param {React.ReactNode} value
 * @param {React.ReactNode} [hint]
 * @param {boolean} [loading]
 * @param {string} [valueColor] - durum anlatan değerler için (uyum yüzdesi vb.)
 */
export default function KpiTile({ label, value, hint, loading, valueColor }) {
  return (
    <Box
      sx={{
        bgcolor: COLORS.white,
        border: `1px solid ${COLORS.slate200}`,
        borderRadius: 3,
        px: CARD_PAD,
        py: 2,
        boxShadow: "0 1px 2px rgba(15,23,42,0.04)",
        minWidth: 0,
      }}
    >
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          color: COLORS.slate500,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: "1.75rem",
          fontWeight: 700,
          color: valueColor || COLORS.slate800,
          lineHeight: 1.2,
          mt: 0.5,
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {loading ? <Skeleton width={72} /> : value}
      </Typography>
      {loading ? (
        <Skeleton width="70%" sx={{ fontSize: TYPO.caption, mt: 0.25 }} />
      ) : hint ? (
        <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate500, mt: 0.25 }}>
          {hint}
        </Typography>
      ) : null}
    </Box>
  );
}
